<!--
 Program: HelpPopup.vue
 Author: SDL
 Description: Popup for menu help
-->
<template>
  <div class="modal-dialog">
    <div class="modal_content">
      <!-- contents -->
      <div class="modal_header">
        <h5>
          {{ $t('sdl.common.label.help') }}
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')" />
      </div>
      <div class="modal_body">
        <div class="form_wrap">
          <div class="fx_form_wrap">
            <div class="form_row">
              <div class="form_item">
                <p class="pre">{{ title }}</p>
                <br/>
                <div class="agree_box">
                  <p class="pre">{{ content }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal_footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="$emit('close')">
          {{ $t('sdl.common.label.close') }}
        </button>
      </div>
    </div>
    <!-- // contents -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import SDLLocale from '@/mixin/SDLLocale';
import _ from 'lodash';
import { DateUtil, SDLUtil, StringUtil, RequestUtil } from '@/utils';

export default {
  data() {
    return {
      title: '',
      content: '',
      textAreaHeight: 'auto',
    };
  },
  props: {
    menu: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({ menus: 'getMenus', helpObj: 'getHelpObj' }),
    // menu() {
    //   if (this.$route.meta.menuId) return _.find(this.menus, ['menuId', this.$route.meta.menuId]);
    //   return undefined;
    // },
    menuDirectoryKr() {
      let str = '';
      _.forEach(this.parentList, (item, idx) => {
        str += `${this.getLabelByLang(item, 'ko_KR')}`;
        if (idx !== this.parentList.length - 1) {
          str += ` > `;
        }
      });
      return str;
    },
    menuDirectoryEn() {
      let str = '';
      _.forEach(this.parentList, (item, idx) => {
        str += `${this.getLabelByLang(item, 'en_US')}`;
        if (idx !== this.parentList.length - 1) {
          str += ` > `;
        }
      });
      return str;
    },
  },
  mixins: [SDLLocale],
  methods: {
    init() {
      const userInfo = SDLUtil.getLoginedUserInfo();
      this.parentList = [...this.menu.parent];
    },
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: 도움말 저장
     */
    saveHelp() {
      const labelJson = {
        ko_KR: this.menuDirectoryKr,
        en_US: this.menuDirectoryEn,
      };
      const param = {
        menuId: this.menu.menuId,
        label: this.menu.label,
        labelJson: JSON.stringify(labelJson),
        title: this.title,
        content: this.content,
      };
      const paramList = [];
      paramList.push(param);
      this.$store.dispatch('UPDATE_HELP_OBJ', paramList).then(() => {
        SDLUtil.alert('sdl.common.message.saved');
      });
    },
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: 도움말 조회
     */
    getHelp() {
      const param = {
        menuId: this.menu.menuId,
        deleteYn: '0',
      };
      this.$store.dispatch('SELECT_HELP_OBJ', param).then(() => {
        this.title = this.helpObj.title;
        this.content = this.helpObj.content;
        // this.resize();
      });
    },
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: textarea resizing
     */
    resize() {
      this.textAreaHeight = 'auto';
      this.$nextTick(() => {
        this.textAreaHeight = `${this.$refs.contentTextarea.scrollHeight + 10}px`;
      });
    },
  },
  created() {
    this.init();
    this.getHelp();
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/view/admin/etc/help/popup/HelpPopup.vue